import * as Yup from "yup";

import { castInputToNumber } from "../../forms";

import type { DirectDepositManualForm } from "./types";
import type { TypeSafeReactLocalization } from "../../../composites";

export const directDepositValidationSchema = ({
  getString,
}: TypeSafeReactLocalization) =>
  Yup.object<DirectDepositManualForm>({
    accountId: Yup.string().required(
      getString("form-generic-validation-required"),
    ),
    employer: Yup.string().required(
      getString("form-generic-validation-required"),
    ),
    allocationMethod: Yup.string().required(),
    valuePercent: Yup.number()
      .nullable()
      .when("allocationMethod", {
        is: "percentage",
        then: (schema) =>
          schema
            .transform(castInputToNumber)
            .required(getString("form-generic-validation-required"))
            .min(1, getString("direct-deposit-form-error-value-percent-min"))
            .max(
              100.0,
              getString("direct-deposit-form-error-value-percent-max"),
            ),
        otherwise: (schema) => schema.nullable(),
      }),
    valueCents: Yup.number()
      .nullable()
      .when("allocationMethod", {
        is: "cents",
        then: (schema) =>
          schema
            .transform(castInputToNumber)
            .required(getString("form-generic-validation-required"))
            .min(1, getString("direct-deposit-form-error-value-cents-min")),
        otherwise: (schema) => schema.nullable(),
      }),
  });
